/* np-shared.js — carousel + card nav, loaded once via layout/theme.liquid */
(function () {
  'use strict';
  if (!window.__npCardNav) {
    window.__npCardNav = true;
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-np-card-prev],[data-np-card-next]');
      if (!b) return;
      e.preventDefault(); e.stopPropagation();
      var s = b.parentElement.querySelector('[data-np-card-slides]');
      if (!s) return;
      var w = s.clientWidth, n = s.children.length;
      var i = Math.round(s.scrollLeft / w) + (b.hasAttribute('data-np-card-next') ? 1 : -1);
      if (i >= n) i = 0; if (i < 0) i = n - 1;
      s.scrollTo({ left: i * w, behavior: 'smooth' });
    });
  }
  if (!customElements.get('np-carousel')) {
    customElements.define('np-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.np-track');
        this.prev  = this.querySelector('.np-arrow--prev');
        this.next  = this.querySelector('.np-arrow--next');
        if (!this.track) return;
        const step = (dir) => this.track.scrollBy({ left: dir * this.track.clientWidth * 0.9, behavior: 'smooth' });
        this.prev && this.prev.addEventListener('click', () => step(-1));
        this.next && this.next.addEventListener('click', () => step(1));
        this.update = this.update.bind(this);
        this.track.addEventListener('scroll', this.update, { passive: true });
        window.addEventListener('resize', this.update);
        this.update();
        const ms = parseInt(this.dataset.autoplay || '0', 10);
        if (ms > 0) {
          this.timer = setInterval(() => {
            if (this.matches(':hover')) return;
            const max = this.track.scrollWidth - this.track.clientWidth;
            if (this.track.scrollLeft >= max - 4) this.track.scrollTo({ left: 0, behavior: 'smooth' });
            else step(1);
          }, ms);
        }
      }
      disconnectedCallback() { clearInterval(this.timer); }
      update() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        if (this.prev) this.prev.disabled = this.track.scrollLeft <= 4;
        if (this.next) this.next.disabled = this.track.scrollLeft >= max - 4;
        const dots = this.querySelectorAll('.np-dot');
        if (dots.length) {
          const i = Math.round(this.track.scrollLeft / Math.max(1, this.track.clientWidth));
          dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
        }
      }
    });
  }
})();